import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import KontentItemMediaGalleryItems from "./kontentItemMediaGalleryItems";
import MediaGallerySection from "../components/mediaGallerySection/mediaGallerySection";
import MediaGallerySlider from "../components/mediaGallerySection/mediaGallerySlider";

const KontentItemMediaGallery = ({ data }) => {
  const gallery = data.value ? data.value[0] : data;

  if (!gallery || !gallery.elements) {
    return null;
  }

  if (gallery.elements.prevent_slider.value.length > 0) {
    return (
      <MediaGallerySection title={gallery.elements.section_title.value}>
        {KontentItemMediaGalleryItems({ data: gallery.elements.media_gallery_items })}
      </MediaGallerySection>
    );
  }

  return (
    <MediaGallerySlider title={gallery.elements.section_title.value}>
      {KontentItemMediaGalleryItems({ data: gallery.elements.media_gallery_items })}
    </MediaGallerySlider>
  );
};

export const query = graphql`
  fragment KontentItemMediaGallery on kontent_item_media_gallery {
    id
    system {
      codename
    }
    elements {
      media_gallery_items {
        value {
          ...KontentitemMediaGalleryItems
        }
      }
      prevent_slider {
        value {
          codename
        }
      }
      section_title {
        value
      }
    }
  }
`;

KontentItemMediaGallery.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemMediaGallery;
